import { SBAComboBox } from "../../../UiComponents/SBADropDown"
import { SBDatePicker } from "../../../UiComponents/SBDatePicker"
import { TreeViewComponent } from "../../../Portfolio/portfolioAttribution/portfolioAttribution"
import { useState } from "react";
import { useEffect } from "react";
import { downloadCS, getDocumentByteArray, getTreeofFamilyClientStatements, getCSSettings, SaveclientSetting, getClientStatementDefaultViewURL, getMarketDataIndices } from "../../../../config/apiConfig";
import { sbaAxios } from "../../../utils/sbaAxios";
import { SBTreeView } from "../../../UiComponents/SBTreeView";
import { SBADropDown } from "../../../UiComponents/SBADropDown";
import moment from "moment";
import axios from "axios";
import { flatVisibleItems } from "@progress/kendo-react-all";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { SBNotify } from "../../../utils/sbNotify";
export const isNativeOnly = process.env.REACT_APP_NEXTGEN_SHOWONYNATIVE  ==='true' ? true:false;
const date = new Date();
const reportDate = new Date(date.setDate(0))
export const ClientStatementTab = () => {
  const blankCS = {
    "ClientStatementId": 0,
    "ClientStatementName": "",
    "AccountId": 0,
    "AccountName": "",
    "ContactId": 0,
    "ContactName": "",
    "selected": false,
    "text": "",
    "FamilyId": 0,
    "checked": false,
    "type": "clientStatement"
  };
  const [familyList, setFamilyList] = useState([]);
  const [familyListBackUP, setFamilyListBackUP] = useState([]);
  const [selectedVersion, setSelectedVersion] = useState({ id: 3, text: 'Native' });
  const [statementDate, setStatementDate] = useState(reportDate);
  const [selectedClientStatement, setSelectedClientStatement] = useState(blankCS);
  const [loading, setLoading] = useState(false);
  const [familySearchText, setFamilySearchText] = useState('');
  const [CSSetting, setCSSetting] = useState(initialSetting);
  const [marketIndex,setMarketIndex]=useState([]);
 
  useEffect(() => {
    getFamilyData();
    setMarketIndexData(setMarketIndex);
    document.title = `Client Statements`;
    
  }, []);
  const versionDataSource = [{ id: 3, text: 'Native' }];
  
  // isNativeOnly ? [{ id: 3, text: 'Native' }] : [
  //       //{ id: 1, text: 'Original' },
  //       { id: 1, text: 'Next Gen' },
  //       { id: 2, text: 'BAM' },
  //       { id: 3, text: 'Native' }];
  const getFamilyData = (searchText) => {
    const keyWord = searchText ? `/${searchText}` : ``
    sbaAxios({ url: `${getTreeofFamilyClientStatements}${keyWord}` }).then(res => {
      setFamilyList(res.map(family => ({ ...family, text: family.FamilyName, checked: false, type: 'family', expanded: false, selected: false, items: family.ClientStatements.map(cs => ({ ...cs, selected: false, text: cs.ClientStatementName, FamilyId: family.FamilyId, checked: false, type: 'clientStatement' })) })));
      setFamilyListBackUP(res.map(family => ({ ...family, text: family.FamilyName, checked: false, type: 'family', expanded: false, selected: false, items: family.ClientStatements.map(cs => ({ ...cs, selected: false, text: cs.ClientStatementName, FamilyId: family.FamilyId, checked: false, type: 'clientStatement' })) })));
    });
  };
  const afterExpand = (e) => {
    setFamilyList(fl => (fl.map(item => {
      if (item.FamilyId === e.item.FamilyId) {
        return { ...item, expanded: !e.item.expanded }
      }
      else return { ...item }
    })))
    setFamilyListBackUP(fl => (fl.map(item => {
      if (item.FamilyId === e.item.FamilyId) {
        return { ...item, expanded: !e.item.expanded }
      }
      else return { ...item }
    })))
  };
  const onItemClick = (e) => {
    if (e.item.type === "clientStatement") {
      const selectedClientSt = e.item;
      const updatedFamily = familyList.map(fam => {
        if (fam.FamilyId === selectedClientSt.FamilyId) {
          const updatedItems = fam.items.map(cs => {
            if (cs.ClientStatementId === selectedClientSt.ClientStatementId) {
              const clientStatement = { ...cs, selected: true }
              setSelectedClientStatement(clientStatement);
              getDefaultView(cs.ClientStatementId).then(res=>{
                if(res)
                {
                  let toSelectVersion=versionDataSource.find(item=>res[0].ViewId==item.id);
                  if(!toSelectVersion)
                  {
                    toSelectVersion=versionDataSource[0];
                  }
                  setSelectedVersion(toSelectVersion);
                  loadCSsetting(selectedClientSt,toSelectVersion.id);
                }
              });
              
              return clientStatement
            }
            else {
              return { ...cs, selected: false }
            }
          })
          return { ...fam, items: updatedItems };
        }
        else {
          const updatedItems = fam.items.map(cs => {
            return { ...cs, selected: false }
          })
          return { ...fam, items: updatedItems };
        }
      });
      const updatedBackUpFamily = familyListBackUP.map(fam => {
        if (fam.FamilyId === selectedClientSt.FamilyId) {
          const updatedItems = fam.items.map(cs => {
            if (cs.ClientStatementId === selectedClientSt.ClientStatementId) {
              const clientStatement = { ...cs, selected: true }
              setSelectedClientStatement(clientStatement);

              return clientStatement
            }
            else {
              return { ...cs, selected: false }
            }
          })
          return { ...fam, items: updatedItems };
        }
        else {
          const updatedItems = fam.items.map(cs => {
            return { ...cs, selected: false }
          })
          return { ...fam, items: updatedItems };
        }
      });
      setFamilyList(updatedFamily);
      setFamilyListBackUP(updatedBackUpFamily);
    }
  };
  const loadCSsetting = async (clientStatement,selectedVersion) => {
    let propertyString = ''
    const accountID = clientStatement.AccountId;
    const ContactID = clientStatement.ContactId;
      if (accountID) {

    if(selectedVersion===2)
      propertyString = 'AccountBAM' + accountID;
    else if(selectedVersion===1)
            propertyString = 'AccountNG' + accountID;
    else if (selectedVersion === 3)
        propertyString = 'AccountNT' + accountID;
    }
      
    else if (ContactID) {
      if(selectedVersion===2)
      propertyString = 'ContactBAM' + ContactID;
      else if(selectedVersion===1)
        propertyString = 'ContactNG' + ContactID;
      else if (selectedVersion === 3)
          propertyString = 'ContactNT' + ContactID;
    };
    const property='statementSBA'+propertyString;
    const reportDate= statementDate.toISOString();
    setLoading(true);
    sbaAxios({ url:`${getCSSettings}${accountID}/${property}/${ContactID}/${reportDate}`}).then((pdfData) => {
      setCSSetting(pdfData);
      setLoading(false);
    });
  };
  const filterFamilyList = (e) => {
    const text = e?.target?.value || "";
    setFamilySearchText(text);
    if (text.length > 0) {
      setFamilyList(familyListBackUP.filter(item => (item.FamilyName.toLowerCase().includes(text.toLowerCase()))))
    }
    else {
      setFamilyList(familyListBackUP);
    }
  };
    const updatedVersion = (e) => {
    if (e.value) {
      setSelectedVersion(e.value);
      if(selectedClientStatement.ClientStatementId)
      loadCSsetting(selectedClientStatement,e.value.id);
    }
  };
  const updateDatePicker = (e) => {
    setStatementDate(new Date(e))
  };
    const getClientStatement = async () => {
    try {
      if (selectedClientStatement.ClientStatementId && reportDate) {

        if (hasDuplicates([CSSetting?.AdditionalIndex || 0, 
          CSSetting?.AdditionalIndex2 || 0, 
          CSSetting?.AdditionalIndex3 || 0, 
          CSSetting?.AdditionalIndex4 || 0])) {
            SBNotify({ Msg: 'Same Index Selected Multiple Times', type: 'error' });
            return 
          }
          
        const stType = selectedVersion.id === 1 ? 'NextGen' : selectedVersion.id === 2 ? 'BAM' : selectedVersion.id === 3 ? 'NT': '';
        const indices = [
          CSSetting.AdditionalIndex,
          CSSetting.AdditionalIndex2,
          CSSetting.AdditionalIndex3,
          CSSetting.AdditionalIndex4
        ];
          const additionalIndex = indices.filter(Boolean).join(',');
          if (CSSetting.IsOnePager) {
              if (additionalIndex == null || additionalIndex=="") {
                  SBNotify({ Msg: 'Please Select Additional Index', type: 'error' });
                  return
              }
          }
        const ddlindices = [
          CSSetting.DDIndex1,
          CSSetting.DDIndex2,
        ];
        const ddlIndex = ddlindices.filter(Boolean).join(',');
        const postData = {
          "ContactID": selectedClientStatement.ContactId,
          "AccountID": selectedClientStatement.AccountId,
          "ReportingMonth": statementDate.toISOString(),
          "DocumentName":CSSetting?.DocumentName,
          "FileName": CSSetting.FileName?.trim()?.length >0 ? CSSetting.FileName : selectedClientStatement.ClientStatementName,
          "CoverPage": CSSetting?.CoverPage || false,
          "PerformanceSummary1": CSSetting?.PerformanceSummary1 || false,
          "PerformanceOverride": CSSetting?.PerformanceOverride || false,
          "ShowChartPage": CSSetting?.ShowChartPage || false,
          "PerformanceDetailPages": CSSetting?.PerformanceDetailPage || false,
          "MarketValueEndOflastYear": CSSetting?.MarketValueEndOflastYear || false,
          "UseQuarterDate": CSSetting?.UseQuarterDate || false,
          "IsAdvised": CSSetting?.IsAdvised || false,
          "UseSecondStrategyIndex": CSSetting?.UseSecondStrategyIndex || false,
          "IsNetOfFees": CSSetting?.IsNetOfFees || false,
          "Indexid": CSSetting?.AdditionalIndex || 0,
          "Indexid2": CSSetting?.AdditionalIndex2 || 0,
          "Index2Name": CSSetting?.AdditionalIndex2Name || "--Select--",
          "IndexName": CSSetting?.AdditionalIndexName || "--Select--",
          "Indexid3": CSSetting?.AdditionalIndex3 || 0,
          "Index3Name": CSSetting?.AdditionalIndex3Name || "--Select--",
          "Indexid4": CSSetting?.AdditionalIndex4 || 0,
          "Index4Name": CSSetting?.AdditionalIndex4Name || "--Select--",
          "HideDetails": CSSetting?.HideDetails || false,
          "Hide3Year": CSSetting?.Hide3Year || false,
          "Hide5Year": CSSetting?.Hide5Year || false,
          "SubTotalSecurity": CSSetting?.SubTotalSecurity || false,
          "PerformanceSummary1AdvisedOnly": CSSetting?.IsAOPortfolioSummary || false,
          "PerformanceSummary2AdvisedOnly": CSSetting?.PerformanceSummary2AdvisedOnly || false,
          "GenerateStatements": CSSetting.GenerateStatements || false,
          "StatusId": CSSetting.StatusId || 0,
          "LastOneYearAnnualized": CSSetting?.LastOneYearAnnualized || false,
          "PerfOverviewTotalType": CSSetting?.PerfOverviewTotalType || 1,
          "UserID": CSSetting?.UserID || 0,
          "Permissions": CSSetting?.Permissions || 0,
          "FileType": CSSetting?.FileType || "pdf",
          "ActionType": CSSetting?.ActionType || "Preview Statement",
          "DocumentDesc": CSSetting?.DocumentDesc || "",
          "DocumentTypeID": CSSetting.DocumentTypeID || 0,
          "DocumentStatusID": CSSetting.DocumentStatusID || 0,
          "FileNameTemplate": "[Contact Name] [Reporting Month]",
          "IsCurrYearMktValue": CSSetting?.HideBeginingOfYear ? false : true,
          "IsRedactedFundNames": CSSetting?.IsRedactedFundNames || false,
          "IsRedactedAccountNames": CSSetting?.IsRedactedAccountNames || false,
          "CashSectionOnly": CSSetting?.CashSectionOnly || false,
          "MoveOtherPerforming": CSSetting?.MoveOtherPerforming || false,
          "OverrideDate": CSSetting?.CashSectionOnly ?CSSetting?.OverrideDate:new Date(),
          "IsRedactedMarketValue": CSSetting?.IsRedactedMarketValue || false,
          "CustomCalculationType": CSSetting?.CustomCalculationType || 1,
          "FiscalYearMonth": CSSetting?.FiscalYearMonth || 5,
          "FiscalYearDay": CSSetting?.FiscalYearDay || 1,
          "FiscalYTDYear": CSSetting?.FiscalYTDYear || 2024,
          "CustomDateStart": CSSetting?.CustomDateStart || null,
          "CustomDateEnd": CSSetting?.CustomDateEnd || null,
           "ShowQYITD": CSSetting?.PerformanceSummary1?CSSetting?.ShowQYITD : false,
          "ClientStatementId": selectedClientStatement.ClientStatementId || 0,
          "PerformanceSummaryCover": CSSetting?.PerformanceSummaryCover || false,
          "SectionName": CSSetting?.SectionName || null,
          "IsLookThrough": CSSetting?.IsLookThrough || false,
          "UseMultiPeriodPerformanceIRR": CSSetting?.UseMultiPeriodPerformanceIRR || false,
          "SupressRealPrivateFlag": CSSetting?.SupressRealPrivateFlag || 1,
          "SupressRAandPEwithPerformanceOverview": CSSetting?.SupressRAandPEwithPerformanceOverview || false,
          "CreditLine": CSSetting?.CreditLine || false,
          "WorldMKTIndices": CSSetting?.WorldMKTIndices || false,
          "IsOnePager": CSSetting?.IsOnePager || false,
          "IsAOPortfolioSummary": CSSetting?.IsAOPortfolioSummary || false,
          "IsPortfolioStatsPage": CSSetting?.IsPortfolioStatsPage || false,
          "PortfolioPerfType": CSSetting?.PortfolioPerfType || "SBAPerforming",
          "UseWeightedIndex": CSSetting?.UseWeightedIndex || false,
          "Period": CSSetting?.Period || "Inception",
          "RRPeriod": CSSetting?.RRPeriod || "Inception",
          "IsRiskReturnChart": CSSetting?.IsRiskReturnChart || false,
          "IsSuppressLabels": CSSetting?.IsSuppressLabels || false,
          "PortfolioRiskReturnType": CSSetting?.PortfolioRiskReturnType || "SBAPerforming",
          "EFLines": CSSetting?.EFLines || "Primary",
          "PrivatePlacementLifeInsurance": CSSetting?.PrivatePlacementLifeInsurance || false,
          "PPLINoAggregation": CSSetting?.PPLINoAggregation || false,
          "PPLILookThrough": CSSetting?.PPLILookThrough || false,
          "sourceOverride": CSSetting?.sourceOverride || null,
          "ClientStatementStatusId": CSSetting?.ClientStatementStatusId || 0,
          "DDIndex1": CSSetting?.DDIndex1 || 0,
          "DDIndex2": CSSetting?.DDIndex2 || 0,
          "ShortVersion": CSSetting?.ShortVersion || false,
          "ShowHistory10Years": CSSetting?.ShowHistory10Years || false,
          "ShowDrawdownChart": CSSetting?.ShowDrawdownChart || false,
          "ShowMarchCoverPage": CSSetting?.ShowMarchCoverPage || false,
          "StatementVersionType": stType,
          "ShowNetContributionsWithdrawals": CSSetting?.ShowNetContributionsWithdrawals || false,
          "ShowNetPnL": CSSetting?.ShowNetPnL || false,
          "Transactions": CSSetting?.Transactions || false,
          "IncludeWeightedIndex": CSSetting?.IncludeWeightedIndex || false,
          "ShowDescription": CSSetting?.ShowDescription || false,
          "ShowAccount": CSSetting?.ShowAccount || false,
          "IsDebug": CSSetting?.IsDebug || false,
          "UseSecondaryIndex": CSSetting?.UseSecondaryIndex || false,
          "AdditionalIndexId": additionalIndex || null,
          "FiscalYear": CSSetting?.FiscalYear || null,
          "IsQTD": CSSetting?.IsQTD || false,
          "WriteTimeSeries": CSSetting?.WriteTimeSeries || false,
          "CreateOnePager": CSSetting?.CreateOnePager || false,
          "ddIndexId": ddlIndex || null,
          "doLookThrough": CSSetting?.doLookThrough || false,
          "InternalUseOnly": CSSetting?.InternalUseOnly || false,
          "ShowTotalYTD": CSSetting?.PerformanceSummaryCover ? CSSetting?.ShowTotalYTD : false,
          "ShowSBTotalYTD": CSSetting?.PerformanceSummary2AdvisedOnly?CSSetting?.ShowSBTotalYTD : false,
           "ShowTotalPortfolio": CSSetting?.HidePercentofTotalPortfolio ? false : true,
          "HideBeginingOfYear": CSSetting?.HideBeginingOfYear ? false : true,
          "HidePercentofTotalPortfolio": CSSetting?.HidePercentofTotalPortfolio ||false,
        }
        setLoading(true);
        sbaAxios({ url: downloadCS, method: 'post', data: postData, responseType: "blob" }).then(data => {
          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          setLoading(false);
          SBNotify({ Msg: 'Report has been Generated Succesfully' })
        }).catch(() => {
          SBNotify({ Msg: 'Error generating Report', type: 'error' })
          setLoading(false);
        });
      }
      else {
        SBNotify({ Msg: 'Please Select Any Client Statement', type: 'error' })
      }
    } catch (error) {

    }
  };
  const getDefaultView= async(ClientStatementId)=>{
    try {
      const URL=getClientStatementDefaultViewURL+ClientStatementId;
      const response=await sbaAxios({ url: URL });
      return response;
    } catch (error) {
      console.log("Error in ClientStatementTab.jsx getDefaultView usung clientStatementID");
      return null;
    }
  }
  const updateCSSetting = (key, value) => {
    setCSSetting(pv => ({ ...pv, [key]: value }))
  };
  const settingsave = () => {
    let PropertyName = "";
      const stType = selectedVersion.id === 1 ? 'NG' : selectedVersion.id === 2 ? 'BAM' : selectedVersion.id === 3 ? 'NT': '';
    if (selectedVersion.text === "BAM") {
      if (selectedClientStatement.ContactId === 0 && selectedClientStatement.AccountId !== 0) {
        PropertyName = 'statementSBAAccountBAM' + selectedClientStatement.AccountId;
      }
      if (selectedClientStatement.AccountId === 0 && selectedClientStatement.ContactId !== 0) {
        PropertyName = 'statementSBAContactBAM' + selectedClientStatement.ContactId;
      }
    }
    else if (selectedVersion.text === "Next Gen") {
      if (selectedClientStatement.ContactId === 0 && selectedClientStatement.AccountId !== 0) {
        PropertyName = 'statementSBAAccountNG' + selectedClientStatement.AccountId;
      }
      if (selectedClientStatement.AccountId === 0 && selectedClientStatement.ContactId !== 0) {
        PropertyName = 'statementSBAContactNG' + selectedClientStatement.ContactId;
      }
    }
    else if (selectedVersion.text === "Native") {
        if (selectedClientStatement.ContactId === 0 && selectedClientStatement.AccountId !== 0) {
            PropertyName = 'statementSBAAccountNT' + selectedClientStatement.AccountId;
        }
        if (selectedClientStatement.AccountId === 0 && selectedClientStatement.ContactId !== 0) {
            PropertyName = 'statementSBAContactNT' + selectedClientStatement.ContactId;
        }
    }
    else {
      if (selectedClientStatement.ContactId === 0 && selectedClientStatement.AccountId !== 0) {
        PropertyName = 'statementSBAAccount' + selectedClientStatement.AccountId;
      }
      if (selectedClientStatement.AccountId === 0 && selectedClientStatement.ContactId !== 0) {
        PropertyName = 'statementSBAContact' + selectedClientStatement.ContactId;
      }
    }
    if (hasDuplicates([CSSetting?.AdditionalIndex || 0, 
      CSSetting?.AdditionalIndex2 || 0, 
      CSSetting?.AdditionalIndex3 || 0, 
      CSSetting?.AdditionalIndex4 || 0])) {
        SBNotify({ Msg: 'Same Index Selected Multiple Times', type: 'error' });
        return 

    }
    const postData = {
      "ContactID": selectedClientStatement.ContactId,
      "AccountID": selectedClientStatement.AccountId,
      "ReportingMonth": CSSetting?.ReportingMonth,
      "DocumentName":CSSetting?.DocumentName,
      "FileName": CSSetting.FileName?.trim()?.length>0 ? CSSetting.FileName : selectedClientStatement.ClientStatementName,
      "CoverPage": CSSetting?.CoverPage || false,
      "PerformanceSummary1": CSSetting?.PerformanceSummary1 || false,
      "PerformanceOverride": CSSetting?.PerformanceOverride || false,
      "ShowChartPage": CSSetting?.ShowChartPage || false,
      "PerformanceDetailPage": CSSetting?.PerformanceDetailPage || false,
      "MarketValueEndOflastYear": CSSetting?.MarketValueEndOflastYear || false,
      "UseQuarterDate": CSSetting?.UseQuarterDate || false,
      "IsAdvised": CSSetting?.IsAdvised || false,
      "UseSecondStrategyIndex": CSSetting?.UseSecondStrategyIndex || false,
      "IsNetOfFees": CSSetting?.IsNetOfFees || false,
      "PropertyName": PropertyName,
      "AdditionalIndex": CSSetting?.AdditionalIndex || 0,
      "AdditionalIndex2": CSSetting?.AdditionalIndex2 || 0,
      "AdditionalIndex2Name": CSSetting?.AdditionalIndex2Name || "--Select--",
      "AdditionalIndexName": CSSetting?.AdditionalIndexName || "--Select--",
      "AdditionalIndex3": CSSetting?.AdditionalIndex3 || 0,
      "AdditionalIndex3Name": CSSetting?.AdditionalIndex3Name || "--Select--",
      "AdditionalIndex4": CSSetting?.AdditionalIndex4 || 0,
      "AdditionalIndex4Name": CSSetting?.AdditionalIndex4Name || "--Select--",
      "HideDetails": CSSetting?.HideDetails || false,
      "Hide3Year": CSSetting?.Hide3Year || false,
      "Hide5Year": CSSetting?.Hide5Year || false,
      "SubTotalSecurity": CSSetting?.SubTotalSecurity || false,
      "PerformanceSummary1AdvisedOnly": CSSetting?.IsAOPortfolioSummary || false,
      "PerformanceSummary2AdvisedOnly": CSSetting?.PerformanceSummary2AdvisedOnly || false,
      "GenerateStatements": CSSetting.GenerateStatements || false,
      "StatusId": CSSetting.StatusId || 0,
      "LastOneYearAnnualized": CSSetting?.LastOneYearAnnualized || false,
      "PerfOverviewTotalType": CSSetting?.PerfOverviewTotalType || 1,
      "UserID": CSSetting?.UserID || 0,
      "Permissions": CSSetting?.Permissions || 0,
      "FileType": CSSetting?.FileType || "pdf",
      "ActionType": CSSetting?.ActionType || "Preview Statement",
      "DocumentDesc": CSSetting?.DocumentDesc || "",
      "DocumentTypeID": CSSetting.DocumentTypeID || 0,
      "DocumentStatusID": CSSetting.DocumentStatusID || 0,
      "FileNameTemplate": "[Contact Name] [Reporting Month]",
      "IsCurrYearMktValue": CSSetting?.HideBeginingOfYear ? false : true,
      "IsRedactedFundNames": CSSetting?.IsRedactedFundNames || false,
      "IsRedactedAccountNames": CSSetting?.IsRedactedAccountNames || false,
      "CashSectionOnly": CSSetting?.CashSectionOnly || false,
      "MoveOtherPerforming": CSSetting?.MoveOtherPerforming || false,
       "OverrideDate": CSSetting?.CashSectionOnly ? CSSetting?.OverrideDate : new Date(),
      "IsRedactedMarketValue": CSSetting?.IsRedactedMarketValue || false,
      "CustomCalculationType": CSSetting?.CustomCalculationType || 1,
      "FiscalYearMonth": CSSetting?.FiscalYearMonth || 5,
      "FiscalYearDay": CSSetting?.FiscalYearDay || 1,
      "FiscalYTDYear": CSSetting?.FiscalYTDYear || 2024,
      "CustomDateStart": CSSetting?.CustomDateStart || null,
      "CustomDateEnd": CSSetting?.CustomDateEnd || null,
       "ShowQYITD": CSSetting?.PerformanceSummary1 ? CSSetting?.ShowQYITD : false,
      "ClientStatementId": selectedClientStatement.ClientStatementId || 0,
      "PerformanceSummaryCover": CSSetting?.PerformanceSummaryCover || false,
      "SectionName": CSSetting?.SectionName || null,
      "IsLookThrough": CSSetting?.IsLookThrough || false,
      "UseMultiPeriodPerformanceIRR": CSSetting?.UseMultiPeriodPerformanceIRR || false,
      "SupressRealPrivateFlag": CSSetting?.SupressRealPrivateFlag || 1,
      "SupressRAandPEwithPerformanceOverview": CSSetting?.SupressRAandPEwithPerformanceOverview || false,
      "CreditLine": CSSetting?.CreditLine || false,
      "WorldMKTIndices": CSSetting?.WorldMKTIndices || false,
      "IsOnePager": CSSetting?.IsOnePager || false,
      "IsAOPortfolioSummary": CSSetting?.IsAOPortfolioSummary || false,
      "IsPortfolioStatsPage": CSSetting?.IsPortfolioStatsPage || false,
      "PortfolioPerfType": CSSetting?.PortfolioPerfType || "SBAPerforming",
      "UseWeightedIndex": CSSetting?.UseWeightedIndex || false,
      "Period": CSSetting?.Period || "Inception",
      "RRPeriod": CSSetting?.RRPeriod || "Inception",
      "IsRiskReturnChart": CSSetting?.IsRiskReturnChart || false,
      "IsSuppressLabels": CSSetting?.IsSuppressLabels || false,
      "PortfolioRiskReturnType": CSSetting?.PortfolioRiskReturnType || "SBAPerforming",
      "EFLines": CSSetting?.EFLines || "Primary",
      "PrivatePlacementLifeInsurance": CSSetting?.PrivatePlacementLifeInsurance || false,
      "PPLINoAggregation": CSSetting?.PPLINoAggregation || false,
      "PPLILookThrough": CSSetting?.PPLILookThrough || false,
      "sourceOverride": CSSetting?.sourceOverride || null,
      "ClientStatementStatusId": CSSetting?.ClientStatementStatusId || 0,
      "DDIndex1": CSSetting?.DDIndex1 || 0,
      "DDIndex2": CSSetting?.DDIndex2 || 0,
      "ShortVersion": CSSetting?.ShortVersion || false,
      "ShowHistory10Years": CSSetting?.ShowHistory10Years || false,
      "ShowDrawdownChart": CSSetting?.ShowDrawdownChart || false,
      "ShowMarchCoverPage": CSSetting?.ShowMarchCoverPage || false,
      "StatementVersionType": stType,
      "ShowNetContributionsWithdrawals": CSSetting?.ShowNetContributionsWithdrawals || false,
      "ShowNetPnL": CSSetting?.ShowNetPnL || false,
      "Transactions": CSSetting?.Transactions || false,
      "IncludeWeightedIndex": CSSetting?.IncludeWeightedIndex || false,
      "ShowDescription": CSSetting?.ShowDescription || false,
      "ShowAccount": CSSetting?.ShowAccount || false,
      "IsDebug": CSSetting?.IsDebug || false,
      "UseSecondaryIndex": CSSetting?.UseSecondaryIndex || false,
      "AdditionalIndexId": CSSetting?.AdditionalIndexId || null,
      "FiscalYear": CSSetting?.FiscalYear || null,
      "IsQTD": CSSetting?.IsQTD || false,
      "WriteTimeSeries": CSSetting?.WriteTimeSeries || false,
      "CreateOnePager": CSSetting?.CreateOnePager || false,
      "ddIndexId": CSSetting?.ddIndexId || null,
      "doLookThrough": CSSetting?.doLookThrough || false,
      "InternalUseOnly": CSSetting?.InternalUseOnly || false,
      "ShowTotalYTD": CSSetting?.PerformanceSummaryCover?CSSetting?.ShowTotalYTD : false,
      "ShowSBTotalYTD": CSSetting?.PerformanceSummary2AdvisedOnly?CSSetting?.ShowSBTotalYTD : false,
      "ShowTotalPortfolio": CSSetting?.HidePercentofTotalPortfolio ? false : true,
      "HideBeginingOfYear": CSSetting?.HideBeginingOfYear || false,
      "HidePercentofTotalPortfolio": CSSetting?.HidePercentofTotalPortfolio ||false
    }
    if(selectedClientStatement.ClientStatementId)
    {
      sbaAxios({
        url: SaveclientSetting,
        method: 'post',
        data: postData,
        responseType: "blob"
      }).then(data => {
        SBNotify({ Msg: 'Setting Saved Successfully' })
      }).catch(() => {
        SBNotify({ Msg: 'Error generating saved Setting', type: 'error' });
        setLoading(false);
      });
    }
   else {
    SBNotify({ Msg: 'Please select Any Client Statement', type: 'error' });
   }
  };
  const getMarketIndexData=async()=>{
    try {
      const resposne=await sbaAxios({url:getMarketDataIndices})
      return  resposne;
    } catch (error) {
      console.log("Error Fetching Data For Market Index");
      return  [];
    }
  };
  const setMarketIndexData=async(setMarketIndex)=>{
    try {
      const marketIndex=await getMarketIndexData();
      setMarketIndex(marketIndex)
    } catch (error) {
      
    }
  };


  return <> {loading ? <><LoadingScreen /></> : <>
    <div className="row">
      <div className="col-md-2 d-flex">
        <div>
          <span class="fw-medium d-block">Report Date</span>
          <SBDatePicker className="form-control" value={moment(statementDate)} onChange={updateDatePicker} />
        </div>
       
      </div>
      <div className="col-md-2 d-flex">
        <div className="w-100">
          <span class="fw-medium d-block">Version</span>
          <SBADropDown
            data={versionDataSource}
            textField={"text"}
            valueField={"id"}
            value={selectedVersion}
            onChange={updatedVersion}
            className="w-100"
          />
        </div>
              <div className="row-items mx-3 ">
                  <i class="far fa-file-pdf mx-2" style={{ color: "red", fontSize: '24px' }} onClick={() => { getClientStatement() }}></i>
                  <i class="far fa-file-excel mx-2" style={{ color: "green", fontSize: '24px' }}></i>
              </div>
      </div>
      <div className="ms-auto row-items col-md-2 d-flex justify-content-end">
              <button class="p-sm-btn my-1" onClick={settingsave}>
                  Save Setting   </button>
      </div>
    </div>
    <div className="row mt-3">
      <div className="col-md-3">
        <div
          className="detail p-2"
          style={{ height: '60vh', overflowY: 'scroll' }}
        >
          <div>
            <label className="mb-1 label">Family Search</label>
            <input
              className="form-control"
              type="text"
              value={familySearchText}
              onChange={(e) => { filterFamilyList(e) }}
            />
          </div>
          <div></div>
          <SBTreeView
            data={familyList}
            expandIcons={true}
            onExpandChange={(e) => { afterExpand(e) }}
            checkboxes={false}
            aria-multiselectable={true}
            item={ClientStatementItem}
            onItemClick={(e) => { onItemClick(e) }}
          />
        </div>
      </div>
      <div className="col-md-4">
        <ContactContainer marketIndex={marketIndex} clientStatement={selectedClientStatement} CSSetting={CSSetting}  setSetting={(key, value) => { updateCSSetting(key, value) }}  setCSSetting={setCSSetting}/>
      </div>
      <div className="col-md-5">
        <PageSelectionContainer marketIndex={marketIndex} setting={CSSetting} setSetting={(key, value) => { updateCSSetting(key, value) }} />
      </div>
    </div></>}
  </>
}
export const ContactContainer = ({ clientStatement , setSetting,CSSetting ,marketIndex,setCSSetting}) => {
  const [CSStatement, setCSStatement] = useState(clientStatement);
  useEffect(() => {
    setCSStatement(clientStatement);
  }, [clientStatement]);
  let displayText = <></>;
  if (CSStatement.ContactId === 0 && CSStatement.AccountId !== 0) {
    displayText = <>
      <span class="fw-bold">Account Name </span>: <span class="fw-medium">{CSStatement.AccountName}</span>
    </>
  }
  else if (CSStatement.AccountId === 0 && CSStatement.ContactId !== 0) {
    displayText = <>
      <span class="fw-bold">Contact Name </span>: <span class="fw-medium">{CSStatement.ContactName}</span>
    </>
  };
  return <>
    <div className="life-science rounded p-3">
      {displayText}
      <div >
        <div className="mt-2">
          <span className="fw-medium">Document Name</span>
          <input type="text" className="form-control" value={CSSetting.DocumentName} onChange={(e)=>{setSetting("DocumentName",e.target.value)}} placeholder="[Account Name][Reporting Month]" />
        </div>
        <div className="mt-2">
          <span className="fw-medium">File Name</span>
          <input type="text" className="form-control" value={CSSetting.FileName} onChange={(e)=>{setSetting("FileName",e.target.value)}}/>
        </div>
        {/* <div className="mt-2">
          <span className="fw-medium">Additional Index</span>
          <SBAComboBox data={marketIndex} valueField={"MarketIndexId"} textField={"MarketIndexName"} value={{MarketIndexId:CSSetting.AdditionalIndex4 , MarketIndexName:CSSetting?.AdditionalIndex4Name}} onChange={(e)=>{
            const marketIndex=e?.value || {MarketIndexId:0 , MarketIndexName:""}
            setCSSetting(value=>({...value,AdditionalIndex4:marketIndex.MarketIndexId,AdditionalIndex4Name:marketIndex.MarketIndexName}))
          }}/>
        </div> */}
        <div className="mt-2">
          <span className="fw-medium">Additional Index 1</span>
          <SBAComboBox data={marketIndex} valueField={"MarketIndexId"} textField={"MarketIndexName"} value={{MarketIndexId:CSSetting?.AdditionalIndex , MarketIndexName:CSSetting?.AdditionalIndexName}} onChange={(e)=>{
            const marketIndex=e?.value || {MarketIndexId:0 , MarketIndexName:""}
            setCSSetting(value=>({...value,AdditionalIndex:marketIndex.MarketIndexId,AdditionalIndexName:marketIndex.MarketIndexName}))
          }}/>
        </div>
        <div className="mt-2">
          <span className="fw-medium">Additional Index 2</span>
          <SBAComboBox data={marketIndex} valueField={"MarketIndexId"} textField={"MarketIndexName"} value={{MarketIndexId:CSSetting?.AdditionalIndex2 , MarketIndexName:CSSetting?.AdditionalIndex2Name}} onChange={(e)=>{
            const marketIndex=e?.value || {MarketIndexId:0 , MarketIndexName:""}
            setCSSetting(value=>({...value,AdditionalIndex2:marketIndex.MarketIndexId,AdditionalIndex2Name:marketIndex.MarketIndexName}))
          }}/>
        </div>
        <div className="mt-2">
          <span className="fw-medium">Additional Index 3</span>
          <SBAComboBox data={marketIndex} valueField={"MarketIndexId"} textField={"MarketIndexName"} value={{MarketIndexId:CSSetting?.AdditionalIndex3 , MarketIndexName:CSSetting?.AdditionalIndex3Name}} onChange={(e)=>{
            const marketIndex=e?.value || {MarketIndexId:0 , MarketIndexName:""}
            setCSSetting(value=>({...value,AdditionalIndex3:marketIndex.MarketIndexId,AdditionalIndex3Name:marketIndex.MarketIndexName}))
          }}/>
        </div>
        <div className="mt-2">
          <span className="fw-medium">Additional Index 4</span>
          <SBAComboBox data={marketIndex} valueField={"MarketIndexId"} textField={"MarketIndexName"} value={{MarketIndexId:CSSetting?.AdditionalIndex4 , MarketIndexName:CSSetting?.AdditionalIndex4Name}} onChange={(e)=>{
            const marketIndex=e?.value || {MarketIndexId:0 , MarketIndexName:""}
            setCSSetting(value=>({...value,AdditionalIndex4:marketIndex.MarketIndexId,AdditionalIndex4Name:marketIndex.MarketIndexName}))
          }}/>
        </div>
      </div>
    </div>
  </>
};
export const PageSelectionContainer = ({ marketIndex,setting, setSetting }) => {
  const PortfolioPref = [
    {ppName: "Advised Performing", ppValue: "SBAPerforming"},
    {ppName: "Total Performing", ppValue: "TotalPerforming"},
    {ppName: "Both", ppValue: "Both"}
  ];
  const PeriodData = [
    {periodName: "3 Yrs", periodValue: "3Yr"},
    {periodName: "5 Yrs", periodValue: "5Yr"},
    {periodName: "Inception", periodValue: "Inception"}
  ];
  const EFLinesData = [
    {efName: "Primary", efValue: "Primary"},
    {efName: "Secondary", efValue: "Secondary"},
    {efName: "Both", efValue: "Both"}
  ];
  const initialPeriod = PeriodData.find((item) => item.periodValue === setting?.Period);
  const initialRRPeriod = PeriodData.find((item) => item.periodValue === setting?.RRPeriod);
  const initialPortfolioPref = PortfolioPref.find((item) => item.ppValue === setting?.PortfolioPerfType);
  const initialRRPortfolioPref = PortfolioPref.find((item) => item.ppValue === setting?.PortfolioRiskReturnType);
  const initialDDIndex1 = marketIndex.find((item) => item.MarketIndexId === setting?.DDIndex1);
  const initialDDIndex2 = marketIndex.find((item) => item.MarketIndexId === setting?.DDIndex2);
  const initialEfLines = EFLinesData.find((item) => item.efValue === setting?.EFLines);
  const [selectedPortfolioPref, setSelectedPortfolioPref] = useState(initialPortfolioPref || PortfolioPref[0]);
  const [selectedRRPortfolioPref, setSelectedRRPortfolioPref] = useState(initialRRPortfolioPref || PortfolioPref[0]);
  const [selectedPeriod, setSelectedPeriod] = useState(initialPeriod || PeriodData[0]);
  const [selectedRRPeriod, setSelectedRRPeriod] = useState(initialRRPeriod || PeriodData[0]);
  const [selectedEFLine, setSelectedEFLine] = useState(initialEfLines || EFLinesData[0]);
  const [selectedDDIndex1, setSelectedDDIndex1] = useState(initialDDIndex1 || marketIndex[0]);
  const [selectedDDIndex2, setSelectedDDIndex2] = useState(initialDDIndex2 || marketIndex[0]);
  return <><div className="life-science rounded p-3">
    <div className="my-2 detail p-2 row">
      <CheckContainer label={'Cover Page'} value={setting?.CoverPage} onChange={(value) => { setSetting('CoverPage', value) }} />
      <CheckContainer label={'Internal Use Only'} value={setting?.InternalUseOnly} onChange={(value) => { setSetting('InternalUseOnly', value) }} />
    </div>
    <div className="my-2 detail p-2 row">
      <CheckContainer label={'Total Portfolio Summary'} value={setting?.PerformanceSummary1} onChange={(value) => { setSetting('PerformanceSummary1', value) }} />
      <CheckContainer label={'Show Net Contributions/ Withdrawals'} value={setting?.ShowNetContributionsWithdrawals} onChange={(value) => { setSetting('ShowNetContributionsWithdrawals', value) }} />
      <CheckContainer label={'Include Weighted Index'} value={setting?.IncludeWeightedIndex} onChange={(value) => { setSetting('IncludeWeightedIndex', value) }} />
      <CheckContainer label={'Advised Portfolio Summary'} value={setting?.IsAOPortfolioSummary} onChange={(value) => { setSetting('IsAOPortfolioSummary', value) }} />
      <CheckContainer label={'Show Net PnL'} value={setting?.ShowNetPnL} onChange={(value) => { setSetting('ShowNetPnL', value) }} />
      {setting?.PerformanceSummary1 ? (
              <CheckContainer
                  label="Show QTD / YTD / ITD"
                  value={setting?.ShowQYITD}
                  onChange={(value) => setSetting('ShowQYITD', value)}
              />
          ) : null}
      </div>
    <div className="my-2 detail p-2 row">
      <CheckContainer label={'Total Account Summary'} value={setting?.PerformanceSummaryCover} onChange={(value) => { setSetting('PerformanceSummaryCover', value) }} />

          <CheckContainer label={'Show Account'} value={setting?.ShowAccount} onChange={(value) => { setSetting('ShowAccount', value) }} />
          {setting?.PerformanceSummaryCover ? (
              <CheckContainer
                  label="Show Total YTD"
                  value={setting?.ShowTotalYTD}
                  onChange={(value) => setSetting('ShowTotalYTD', value)}
              />
          ) : <span> </span>}

      <CheckContainer label={'Advised Account Summary'} value={setting?.PerformanceSummary2AdvisedOnly} onChange={(value) => { setSetting('PerformanceSummary2AdvisedOnly', value) }} />
      <CheckContainer label={'Show Description'} value={setting?.ShowDescription} onChange={(value) => { setSetting('ShowDescription', value) }} />
      {(setting?.PerformanceSummaryCover || setting?.PerformanceSummary2AdvisedOnly ) && <CheckContainer label={'Redacted Account Name'}  value={setting?.IsRedactedAccountNames} 
       onChange={(value) => { setSetting('IsRedactedAccountNames', value) }} />}
          {setting?.PerformanceSummary2AdvisedOnly ? (
              <CheckContainer
                  label="Show SB Total YTD"
                  value={setting?.ShowSBTotalYTD}
                  onChange={(value) => setSetting('ShowSBTotalYTD', value)}
              />
          ) : null}

      </div>
    <div className="my-2 detail p-2 row">
      <CheckContainer label={'Multi-Period Performance'} value={setting?.PerformanceDetailPage} onChange={(value) => { setSetting('PerformanceDetailPage', value) }} nowrap={true}/>
      <div className="detail p-2 bg-secondary row m-0" style={{ "--bs-bg-opacity": .2 }} >
        <CheckContainer label={'Use Quarter to Date'} value={setting?.UseQuarterDate} onChange={(value) => { setSetting('UseQuarterDate', value) }} />
        <CheckContainer label={'Advised'} value={setting?.IsAdvised} onChange={(value) => { setSetting('IsAdvised', value) }} />
        <CheckContainer label={'Redacted Asset Names'} value={setting?.IsRedactedFundNames} onChange={(value) => { setSetting('IsRedactedFundNames', value) }} />
        <CheckContainer label={'Net of Fees'} value={setting?.IsNetOfFees} onChange={(value) => { setSetting('IsNetOfFees', value) }} />
        <CheckContainer label={'Redacted Market Value'} value={setting?.IsRedactedMarketValue} onChange={(value) => { setSetting('IsRedactedMarketValue', value) }} />
        <CheckContainer label={'Use Secondary Strategy Index'} value={setting?.UseSecondStrategyIndex} onChange={(value) => { setSetting('UseSecondStrategyIndex', value) }} />
        <CheckContainer label={'Cash Section Only'} value={setting?.CashSectionOnly} onChange={(value) => { setSetting('CashSectionOnly', value)}} />
        <CheckContainer label={'Move Other Performing Assets'} value={setting?.MoveOtherPerforming} onChange={(value) => { setSetting('MoveOtherPerforming', value) }} />
        <span > </span>
              {setting?.CashSectionOnly ? (
                  <div className="col-md-4">
                      <div className="row">
                          <div className="col-12">
                              <span className="fw-medium d-block">Override Date</span>
                          </div>
                      </div>
                      <div className="row mt-2">
                          <div className="col-12">
                              <SBDatePicker
                                  className="form-control"
                                  value={moment(setting?.OverrideDate==="01/01/0001"?new Date():setting?.OverrideDate)}
                                  onChange={(value) => setSetting('OverrideDate', value)}
                              />
                          </div>
                      </div>
                  </div>
              ) : null}
              <span > </span>
              <span > </span>
              <CheckContainer label={'Hide Details'} value={setting?.HideDetails} onChange={(value) => { setSetting('HideDetails', value) }} />            
              <CheckContainer label={'Hide Begining of Year Market Value'} value={setting?.HideBeginingOfYear} onChange={(value) => { setSetting('HideBeginingOfYear', value) }} />
              <span > </span>
              <CheckContainer label={'Subtotal Securities'} value={setting?.SubTotalSecurity} onChange={(value) => { setSetting('SubTotalSecurity', value) }} />
              <CheckContainer label={'Hide % of Total Portfolio'} value={setting?.HidePercentofTotalPortfolio} onChange={(value) => { setSetting('HidePercentofTotalPortfolio',value)}}/> 
      </div>
    </div>
     <div className="detail my-2 p-2 row">
        <CheckContainer label={'PPLI'} value={setting?.PrivatePlacementLifeInsurance} onChange={(value) => { setSetting('PrivatePlacementLifeInsurance', value) }} />
        <CheckContainer label={'PPLI No Aggregation'} value={setting?.PPLINoAggregation} onChange={(value) => { setSetting('PPLINoAggregation', value) }} />
        <CheckContainer label={'PPLI LookThrough'} value={setting?.PPLILookThrough} onChange={(value) => { setSetting('PPLILookThrough', value) }} />
      </div>
      {/* <div className="detail my-2 p-2">
        <CheckContainer label={'Multi-Period IRR'} value={setting?.UseMultiPeriodPerformanceIRR} onChange={(value)=>{setSetting('UseMultiPeriodPerformanceIRR',value)}} disabled  />
      </div> */}
      <div className="detail my-2 p-2 row">
        <CheckContainer label={'Portfolio Statistics Page'}    value={setting?.IsPortfolioStatsPage} onChange={(value) => { setSetting('IsPortfolioStatsPage', value) }} />
        <CheckContainer label={'Use Weighted Index'} value={setting?.UseWeightedIndex} onChange={(value) => { setSetting('UseWeightedIndex', value) }} />
        <CheckContainer label={'Portfolio Statistics Chart'}  value={setting?.IsOnePager} onChange={(value) => { setSetting('IsOnePager', value) }} />
        {
          (setting?.IsOnePager === true) ?
          <div className="detail p-2 bg-secondary row m-0" style={{ "--bs-bg-opacity": .2 }} >
            <div className="row">
              <div className="col-6">
                <label className="label">Portfolio</label>
                  <div className="d-flex align-items-center">
                    <SBAComboBox
                      className="w-100"
                      data={PortfolioPref}
                      textField={"ppName"}
                      valueField={"ppValue"}
                      value={selectedPortfolioPref}
                      onChange={(e) => {
                        setSelectedPortfolioPref(e.value);
                        setSetting('PortfolioPerfType', e.value.ppValue);
                      }}
                      popupSettings={{ className: "modalDD" }}
                    />
                  </div>
              </div>
              <div className="col-6">
              <label className="label">Period</label>
                  <div className="d-flex align-items-center">
                    <SBAComboBox
                      className="w-100"
                      data={PeriodData}
                      textField={"periodName"}
                      valueField={"periodValue"}
                      value={selectedPeriod}
                      onChange={(e) => {
                        setSelectedPeriod(e.value);
                        setSetting('Period', e.value.periodValue);
                      }}
                      popupSettings={{ className: "modalDD" }}
                    />
                  </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
              <label className="label">Draw Down Index 1</label>
                  <div className="d-flex align-items-center">
                    <SBAComboBox
                      className="w-100"
                      data={marketIndex}
                      textField={"MarketIndexName"}
                      valueField={"MarketIndexId"}
                      value={selectedDDIndex1}
                      onChange={(e) => {
                        setSelectedDDIndex1(e.value);
                        setSetting('DDIndex1', e.value.MarketIndexId);
                      }}
                      popupSettings={{ className: "modalDD" }}
                    />
                  </div>
              </div>
              <div className="col-6">
              <label className="label">Draw Down Index 2</label>
                  <div className="d-flex align-items-center">
                    <SBAComboBox
                      className="w-100"
                      data={marketIndex}
                      textField={"MarketIndexName"}
                      valueField={"MarketIndexId"}
                      value={selectedDDIndex2}
                      onChange={(e) => {
                        setSelectedDDIndex2(e.value);
                        setSetting('DDIndex2', e.value.MarketIndexId);
                      }}
                      popupSettings={{ className: "modalDD" }}
                    />
                  </div>
              </div>
            </div>
          </div>:null
        }
      </div>
      <div className="detail my-2 p-2 row">
        <CheckContainer label={'Risk / Return Chart'} value={setting?.IsRiskReturnChart} onChange={(value) => { setSetting('IsRiskReturnChart', value) }} />
        {
        (setting?.IsRiskReturnChart === true) ?
          <div className="detail p-2 bg-secondary row m-0" style={{ "--bs-bg-opacity": .2 }} >
            <div className="row">
              <div className="col-6">
                <label className="label">Portfolio</label>
                  <div className="d-flex align-items-center">
                    <SBAComboBox
                      className="w-100"
                      data={PortfolioPref}
                      textField={"ppName"}
                      valueField={"ppValue"}
                      value={selectedRRPortfolioPref}
                      onChange={(e) => {
                        setSelectedRRPortfolioPref(e.value);
                        setSetting('PortfolioRiskReturnType',e.value.ppValue);
                      }}
                      popupSettings={{ className: "modalDD" }}
                    />
                  </div>
              </div>
              <div className="col-6">
              <label className="label">Period</label>
                  <div className="d-flex align-items-center">
                    <SBAComboBox
                      className="w-100"
                      data={PeriodData}
                      textField={"periodName"}
                      valueField={"periodValue"}
                      value={selectedRRPeriod}
                      onChange={(e) => {
                        setSelectedRRPeriod(e.value);
                        setSetting('RRPeriod', e.value.periodValue);
                      }}
                      popupSettings={{ className: "modalDD" }}
                    />
                  </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
              <label className="label">EF Lines</label>
                  <div className="d-flex align-items-center">
                    <SBAComboBox
                      className="w-100"
                      data={EFLinesData}
                      textField={"efName"}
                      valueField={"efValue"}
                      value={selectedEFLine}
                      onChange={(e) => {
                        setSelectedEFLine(e.value);
                        setSetting('EFLines', e.value.efValue);
                      }}
                      popupSettings={{ className: "modalDD" }}
                    />
                  </div>
              </div>
              <div className="col-6">
              <CheckContainer label={'Suppress Labels'} value={setting?.IsSuppressLabels} onChange={(value) => { setSetting('IsSuppressLabels', value) }} />
              </div>
            </div>
          </div>:null
        }
      </div>

  </div></>
};
const CheckContainer = ({ label, value, onChange, nowrap, ...props }) => {
    return (
        <div className="col-md-4 p-2">
            <span className="mx-2 d-flex">
                <input
                    type="checkbox"
                    checked={value}
                    onChange={(e) => { onChange(e.target.checked) }}
                    {...props}
                />
                {/* <label className="ms-2 wrap-label">{label}</label> */}
                <label className={`ms-2 ${nowrap ? 'nowrap-label' : 'wrap-label'}`}>{label}</label>
            </span>
        </div>
    );
};

const ClientStatementItem = (props) => {
  const type = props.item.type;
  if (type == "family") {
    return <> {props.item.text}</>
  }
  else if (type == "clientStatement") {
    if (props.item.ContactId === 0) {
      const tittleText = `Account - ID: ${props.item.AccountId}, CS - ID : ${props.item.ClientStatementId}`;
      return <span title={tittleText}>{props.item.text}</span>
    }
    else if (props.item.AccountId === 0) {
      const tittleText = `Contact - ID: ${props.item.ContactId}, CS - ID : ${props.item.ClientStatementId}`;
      return <span title={tittleText}>{props.item.text}</span>
    }
  }
}
const initialSetting = {
  "ContactID": 0,
  "AccountID": 0,
  "ReportingMonth": "2024-05-09T00:00:00.000Z",
  "FileName": "",
  "CoverPage": false,
  "DocumentName":"",
  "PerformanceSummary1": false,
  "PerformanceOverride": false,
  "ShowChartPage": false,
  "PerformanceDetailPage": false,
  "MarketValueEndOflastYear": false,
  "UseQuarterDate": false,
  "IsAdvised": false,
  "UseSecondStrategyIndex": false,
  "IsNetOfFees": false,
  "AdditionalIndex": 0,
  "AdditionalIndex2": 0,
  "AdditionalIndex2Name": "",
  "AdditionalIndexName": "",
  "AdditionalIndex3": 0,
  "AdditionalIndex3Name": "",
  "AdditionalIndex4": 0,
  "AdditionalIndex4Name": "",
  "HideDetails": false,
  "Hide3Year": false,
  "Hide5Year": false,
  "SubTotalSecurity": false,
  "PerformanceSummary1AdvisedOnly": false,
  "PerformanceSummary2AdvisedOnly": false,
  "GenerateStatements": false,
  "StatusId": 0,
  "LastOneYearAnnualized": false,
  "PerfOverviewTotalType": 0,
  "UserID": 0,
  "Permissions": 0,
  "FileType": "",
  "ActionType": "",
  "DocumentDesc": "",
  "DocumentTypeID": 0,
  "DocumentStatusID": 0,
  "FileNameTemplate": "",
  "IsCurrYearMktValue": false,
  "IsRedactedFundNames": false,
  "CashSectionOnly": false,
  "MoveOtherPerforming": false,
  "OverrideDate": null,
  "IsRedactedMarketValue": false,
  "CustomCalculationType": 0,
  "FiscalYearMonth": 0,
  "FiscalYearDay": 0,
  "FiscalYTDYear": 0,
  "CustomDateStart": null,
  "CustomDateEnd": null,
  "ShowQYITD": false,
  "ClientStatementId": 0,
  "PerformanceSummaryCover": false,
  "SectionName": null,
  "IsLookThrough": false,
  "UseMultiPeriodPerformanceIRR": false,
  "SupressRealPrivateFlag": false,
  "SupressRAandPEwithPerformanceOverview": false,
  "CreditLine": false,
  "WorldMKTIndices": false,
  "IsOnePager": false,
  "IsAOPortfolioSummary": false,
  "IsPortfolioStatsPage": false,
  "PortfolioPerfType": "",
  "UseWeightedIndex": false,
  "Period": "",
  "RRPeriod": "",
  "IsRiskReturnChart": false,
  "IsSuppressLabels": false,
  "PortfolioRiskReturnType": "",
  "EFLines": "",
  "PrivatePlacementLifeInsurance": false,
  "PPLINoAggregation": false,
  "PPLILookThrough": false,
  "sourceOverride": null,
  "ClientStatementStatusId": 0,
  "DDIndex1": 0,
  "DDIndex2": 0,
  "ShortVersion": false,
  "ShowHistory10Years": false,
  "ShowDrawdownChart": false,
  "ShowMarchCoverPage": false,
  "StatementVersionType": "",
  "ShowNetContributionsWithdrawals": false,
  "ShowNetPnL": false,
  "Transactions": false,
  "IncludeWeightedIndex": false,
  "ShowDescription": false,
  "ShowAccount": false,
  "IsDebug": false,
  "UseSecondaryIndex": false,
  "AdditionalIndexId": null,
  "FiscalYear": null,
  "IsQTD": false,
  "WriteTimeSeries": false,
  "CreateOnePager": false,
  "ddIndexId": null,
  "doLookThrough": false,
  "InternalUseOnly": false,
  "ShowTotalYTD": false,
  "ShowSBTotalYTD": false,
    "ShowTotalPortfolio": false,
  "HidePercentofTotalPortfolio":false ,
  "IsRedactedAccountNames":false
};
function hasDuplicates(data) {
  const filtereddata=data.filter(val => val !== null && val !== 0);
  return new Set(filtereddata).size < filtereddata.length;
}